var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../classes/runtime/Runtime';
import { QuestionBarDifficulty } from './Question/QuestionBarDifficulty';
import { GradeDisplay } from '../CycleBar/Grade/GradeDisplay';
let QuestionBarDefer = class QuestionBarDefer extends React.PureComponent {
    render() {
        const { app } = this.props;
        const { numberOfRemainingQuestions } = app.funnel.funnelMixed.mixedFilter;
        return (React.createElement("div", { style: {
                background: 'rgba(255,255,255,0.5)',
                display: 'flex',
                flexDirection: 'column',
                width: 150,
                alignItems: 'stretch',
                fontSize: 15,
                marginRight: 10,
                marginTop: 10,
                borderRadius: 5,
                padding: 10,
            } },
            React.createElement("h3", { style: { fontSize: 18 } },
                "Frage\u00A0",
                app.cycle.frontalNumber,
                "\u00A0von\u00A0",
                app.cycle.numberOfQuestionsInCycle),
            React.createElement(QuestionBarDifficulty, { question: app.solidQuestion }),
            this.questionBarRating,
            React.createElement(GradeDisplay, { app: app }),
            numberOfRemainingQuestions < 100 && (React.createElement("div", { style: { fontSize: 18, color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500 } },
                "Fragen offen: ",
                React.createElement("b", null, numberOfRemainingQuestions)))));
    }
    get questionBarRating() {
        if (!runtime.availablePackages.Lazy)
            return null;
        const { QuestionBarRating } = runtime.availablePackages.Lazy.components;
        return React.createElement(QuestionBarRating, { question: this.props.app.solidQuestion });
    }
};
QuestionBarDefer = __decorate([
    observer
], QuestionBarDefer);
export { QuestionBarDefer };
